import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from 'src/app/app.component';

import { MenuDetailComponent, MenuListComponent } from '@serengeti/serengeti-menu';
import { AuthService } from 'src/app/utility/auth/auth.service';

const routes: Routes = [
  { path: 'main', component: AppComponent, canActivate: [AuthService], children: [
      { path: 'setting/menu/list', component: MenuListComponent, outlet: 'content', data: { title: 'menu.list.title', root: true } },
      { path: 'setting/menu/create', component: MenuDetailComponent, outlet: 'content', data: { title: 'menu.create.title' } },
      { path: 'setting/menu/detail/:id/', component: MenuDetailComponent, outlet: 'content', data: { title: 'menu.detail.title' } },
      { path: 'setting/menu/createChild/:parentId/', component: MenuDetailComponent, outlet: 'content' },
    ]}
];

@NgModule({
  declarations: [
  ],
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true }),
    CommonModule
  ],
  exports: [
  ]
})
export class AppRoutingMenuModule { }
